import React from "react";
import { Redirect, withRouter } from "react-router";
import { compose } from "redux";

import withStaticPageRedirects from "../../../../../hocs/withStaticPageRedirects";
import { findStaticPageRedirectTarget } from "../../../../../lib/staticPageRedirects/findStaticPageRedirectTarget";
import Loader from "../../Loader";

function StaticPageRedirectGuard({
  children,
  location,
  authToken,
  userID,
  initialAuthCheckPending,
  cachedMappings
}) {
  const isGuestSession = !authToken && !userID;
  const awaitingAuthResolution =
    initialAuthCheckPending && (authToken || userID);

  if (awaitingAuthResolution) {
    return <Loader />;
  }

  if (isGuestSession && !Array.isArray(cachedMappings)) {
    return <Loader />;
  }

  if (isGuestSession) {
    const targetUrl = findStaticPageRedirectTarget(
      cachedMappings,
      location.pathname
    );

    if (targetUrl) {
      return <Redirect to={targetUrl} />;
    }
  }

  return children;
}

export default compose(
  withRouter,
  withStaticPageRedirects
)(StaticPageRedirectGuard);
